<template>
<section class="w-100 front-section">
  <div class="container-fluid hv-100">

    <div class="row p-md-4 pb-md-0 p-3 pt-5" style="overflow-x:hidden; padding-top: 4rem !important;">
      <div class="border-around-rounded p-3" style="margin-top: 60px;">
        <FrontHeader></FrontHeader>
        <div class="py-5 invisible">&nbsp;</div>

        <div class="row justify-content-center">
          <div class="col-md-5 col-12">

          <div class="d-block text-center">
            <h3 class="text-white font-family-poppins mb-4">Frequently Asked questions</h3>
          </div>

          <div class="py-2 invisible">&nbsp;</div>


          <div id="accordion" class="faq-accordion">
            <div class="card custom-card-transparent">
              <div class="card-header" id="headingOne">
                <h5 class="mb-0">
                  <div class="font-grey" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Is it free for Creators to use?
                  </div>
                </h5>
              </div>

              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body">
                  Stella is completely free to use for Creators. Creators are able to set their own prices for subscriptions, bonus content, custom requests, and messages. The platform fee is 20% and payments are made monthly.
                  <br>
                  <br>
                  For Fans:
                  <br>
                  <br>
                  Fans will be charged at the point of transaction via Stripe, our secure payment processor. If for any reason, you experience any issues please feel free to reach out to hello@stella.so </div>
              </div>
            </div>
            <div class="card custom-card-transparent">
              <div class="card-header" id="headingTwo">
                <h5 class="mb-0">
                  <div class="font-grey collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Returns and Refunds
                  </div>
                </h5>
              </div>
              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                <div class="card-body">
                   All items are non-refundable. Creators pour their heart and soul into making content. It is more often than not their main stream of income and we ask that you consider this before making any purchases or requesting any refunds.
                   <br>
                  We accept payments in US dollars. </div>
              </div>
            </div>
            <div class="card custom-card-transparent">
              <div class="card-header" id="headingThree">
                <h5 class="mb-0">
                  <div class="font-grey collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    How do I delete my account?
                  </div>
                </h5>
              </div>
              <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                   You may request account deletion by emailing us at hello@stella.so </div>
              </div>
            </div>
          </div>






          </div>
        </div>
      </div>



    </div>

  </div>
  <FrontFooter></FrontFooter>
</section>


</template>

<script>

import FrontHeader from '@/components/module/front/FrontHeader'
import FrontFooter from '@/components/module/front/FrontFooter'
import titleMixin from "../../../mixin/title-mixin";


export default {
  name: 'FAQ',
  title: 'FAQ',
  mixins: [titleMixin],
  components: {FrontFooter,FrontHeader},
  created() {
  },
  beforeMount() {
  },
  computed: {},
  methods: {
    navigateToPage() {
      this.$router.push('/help'); // Replace with the actual route path
    }
  }
};
</script>

<style scoped>
/* Glassmorphism FAQ Card */
.faq-accordion .card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  margin-bottom: 16px;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-accordion .card:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(197, 111, 209, 0.3);
}

.faq-accordion .card-header {
  background: transparent;
  border-bottom: none;
  padding: 0;
}

.faq-accordion .card-header .font-grey {
  padding: 24px;
  color: white;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Remove default bootstrap outline */
.faq-accordion .card-header .font-grey:focus,
.faq-accordion .card-header .font-grey:active {
  outline: none;
  box-shadow: none;
}

.faq-accordion .card-header .font-grey::after {
  content: '+';
  font-size: 24px;
  font-weight: 300;
  color: #C56FD1;
  transition: transform 0.3s ease;
  line-height: 1;
}

.faq-accordion .card-header .font-grey:not(.collapsed)::after {
  content: '−';
}

.faq-accordion .card-body {
  color: rgba(255, 255, 255, 0.7);
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  line-height: 1.6;
  padding: 0 24px 24px 24px;
}

.front-section {
  background: transparent;
  min-height: 100vh;
}
</style>
